import { lazy } from 'react';
import Loadable from 'ui-component/Loadable';

const UploadFormatFileValidating = Loadable(lazy(() => import('../views/UsersManagement/components/UploadFormatFileValidating')));

const UploadFormRoute = [
  {
    path: 'upload-format-file-validating',
    element: <UploadFormatFileValidating />
  }
];

export default UploadFormRoute;
